export const companiesCompanyIdGranularPermissionOptInStatus =
  "/companies/:company_id/granular_permission_opt_in_status";
